/** A Web project's custom instructions (GET and PUT /projects/{id}/custom-instructions):
 *  free text the AI Model follows on conventions, such as folder structure, naming
 *  and coding standards, from the project's next message on. Editors only. How the
 *  platform keeps and counts the text: utils/stackPicker.ts. */
import axios from 'axios';

import api from '../utils/axios';

export interface CustomInstructions {
  /** As the platform keeps them; "" when the project has none. */
  text: string;
  updated_by?: string | null;
  /** Epoch seconds. */
  updated_at?: number | null;
  /** The cap on their length, in characters. */
  max_chars: number;
}

export async function fetchCustomInstructions(projectId: string): Promise<CustomInstructions> {
  const response = await api.get(`/projects/${projectId}/custom-instructions`);
  return response.data;
}

/** Saves them; "" removes them. Answers as fetchCustomInstructions does after the change. */
export async function saveCustomInstructions(projectId: string, text: string): Promise<CustomInstructions> {
  const response = await api.put(`/projects/${projectId}/custom-instructions`, { text });
  return response.data;
}

/** The message a refused request carries for the user, the platform's own plain
 *  words, or null for anything else, which is never shown as it is. A 404 never
 *  gets here: utils/axios.ts sends the user to /404 first, as for any project. */
export function refusalMessage(error: unknown): string | null {
  if (!axios.isAxiosError(error)) return null;
  const status = error.response?.status;
  const detail = error.response?.data?.detail;
  return (status === 400 || status === 503) && typeof detail === 'string' ? detail : null;
}
